import { connect } from "react-redux";
import MaterialReceiveForm from "./materialReceiveForm";
import { bindActionCreators } from "redux";
import {
  documentUploadUrlPublic,
  imageUploadUrlPublic
} from "services/redux/fileUpload/action";
import {getChallanItems,saveMaterialReceive} from "../../../services/redux/installation/hardwareInstall/action";
import {
  getMateriaById,
  getBrandById,
} from "services/redux/sales/postSales/contractCorporate/action";

const mapStateToProps = (state) => ({
  documentUrlData: state.fileUploadReducer.imageUrlData,
  challanLineItems: state.hardwareInstallReducer.challanItems,
  getMaterial: state.contractCorporateReducer.getMaterial,
  getBrand: state.contractCorporateReducer.getBrand,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageUploadUrlPublic,
      getChallanItems,
      getMateriaById,
      saveMaterialReceive
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MaterialReceiveForm);
